import React from 'react';
import { Button } from './ui/Button';
export function TestimonialsSection() {
  return <section className="py-10 bg-alt border-y border-[#D9D0C1]" data-id="element-264">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
        <div className="text-center mb-10" data-id="element-266">
          <h2 className="text-3xl md:text-4xl font-serif text-title mb-4" data-id="element-267">
            Mujeres reales. Sin exposición.
          </h2>
          <p className="text-body" data-id="element-268">
            Privacidad primero. Método paso a paso para publicar sin mostrar tu
            cara.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-269">
          {/* Testimonial 1 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-270">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-271">
              "Antes me frenaba el miedo a que me reconocieran. Ahora publico
              con una cuenta anónima sin ansiedad. Lo que cambió fue tener una
              estructura clara para saber qué subir y cuándo."
            </p>
            <div className="flex items-center" data-id="element-272">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 flex items-center justify-center font-serif text-accent text-lg" data-id="element-273">
                L
              </div>
              <div data-id="element-274">
                <p className="font-medium text-title text-sm" data-id="element-275">Laura</p>
                <p className="text-xs text-body" data-id="element-276">Madrid · +30 · oficina</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-277">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-278">
              "La cámara me bloqueaba y lo dejaba siempre para «mañana». Con el
              método empecé a publicar sin exponerme. Tener pasos y plantillas
              me quitó la presión de improvisar."
            </p>
            <div className="flex items-center" data-id="element-279">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 flex items-center justify-center font-serif text-accent text-lg" data-id="element-280">
                C
              </div>
              <div data-id="element-281">
                <p className="font-medium text-title text-sm" data-id="element-282">Carmen</p>
                <p className="text-xs text-body" data-id="element-283">Valencia · introvertida</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-284">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-285">
              "No es un curso vendehumo. Es una guía práctica con pasos claros.
              Empecé a publicar la primera semana sin mostrar mi cara ni
              inventar nada."
            </p>
            <div className="flex items-center" data-id="element-286">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 flex items-center justify-center font-serif text-accent text-lg" data-id="element-287">
                E
              </div>
              <div data-id="element-288">
                <p className="font-medium text-title text-sm" data-id="element-289">Elena</p>
                <p className="text-xs text-body" data-id="element-290">España · poco tiempo</p>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Micro-row */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-10 text-sm text-body" data-id="element-291">
          <span data-id="element-292">✦ Sin cámara</span>
          <span data-id="element-293">✦ Sin nombre real</span>
          <span data-id="element-294">✦ Con estructura (pasos + plantillas)</span>
        </div>

        {/* CTA #3 */}
        <div className="text-center mt-10" data-id="element-295">
          <Button size="lg" withArrow data-id="element-296">
            Acceder al pack ahora
          </Button>
          <p className="text-xs text-body mt-3" data-id="element-297">
            Hoy 12€ · Pack digital · Privacidad primero · Garantía 14 días
          </p>
        </div>
      </div>
    </section>;
}